export default __webpack_public_path__ + "static/media/January2020.cd7fa58e.png";